// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_jO6","cls2":"RelatedPapers-cls2_s6r RelatedPapers-cls1_jO6"};